module.exports = __webpack_public_path__ + "static/img/xuanzhongchangjing.png@2x.78168fdb.png";